import memberDetailsService from "@services/memberDetails.service";
import membersService from "@services/members.service";
import { useVitalsStore } from "@stores/vitalsStore";
import React, { createContext, useContext, useEffect, useState, useMemo } from "react";

export interface PopupState {
  isOpen: boolean
  vital?: string
}

export interface PopupProps extends PopupState {
  open: (vital: string) => void
  close: () => void
}

const usePopup: () => PopupProps = () => {
  const [{ isOpen, vital }, setState] = useState<PopupState>({ isOpen: false })

  const open = (vital: string) => {
    setState(
      {
        isOpen: true,
        vital
      }
    )
  }

  const close = () => setState({ isOpen: false })
  
  return {
    isOpen,
    vital,
    open,
    close
  }
}

export type Vital = {
  icon: string,
  actualName: string,
  displayName: string,
  value: string,
  inRange: 'Y' | 'N' | 'NA',
  refreshDate: string,
  canEdit: boolean,
  haveGraph: boolean,
}

export type Vitals = Array<Vital>;

export type UseVitalsProps = {
};

export type UseVitals = (props: UseVitalsProps) => {
  patientID: string,
  vitalLoader?: boolean;
  vitals: Vital[];
  dataCardId?: number;
  editPopup?: PopupProps;
  graphPopup?: PopupProps;
  refresh?: (x: any) => void,
  patientId?: any
};

const defaultVitalsValue: Vital[] = [];

export const useVitals: UseVitals = function (props) {
  const patientID = useMemo(() => {
    const cMember = membersService?.getCurrentMember;

    return cMember?.patient_id;
  }, [membersService?.getCurrentMember]);

  const [vitals, setvitals, dataCardId, setdataCardId, patientId, setPatientId, vitalLoader, setVitalLoader] = useVitalsStore((store) => [store.data, store.setdata, store.dataCardId, store.setdataCardId, store.patientId, store.setPatientId, store.vitalLoader, store.setVitalLoader]);

  const editPopup = usePopup()
  const graphPopup = usePopup()

  const refresh = React.useCallback(
    (panelExpanded: any) => {
      if (panelExpanded?.length > 0) {
        setVitalLoader(true);
        memberDetailsService.fetchVitals(patientID).subscribe(
          (response) => {
            let vitals = response?.data?.data?.vitals || [];
            setvitals(vitals);
            setdataCardId(response?.data?.data?.datacardId);
            setPatientId(response?.data?.data?.patientId)
            setVitalLoader(false);
          },
          (err) => {
            setvitals([]);
            setdataCardId(0);
            setVitalLoader(false);
          }
        );
      } else console.log("Data card is available, no API call");
    },
    [patientID, setvitals, setdataCardId, setPatientId]
  );


  return {
    patientID,
    vitalLoader,
    vitals,
    dataCardId,
    editPopup,
    graphPopup,
    refresh,
    patientId
  };
};

export const VitalsContext = createContext<ReturnType<UseVitals>>({
  patientID: '',
  vitals: defaultVitalsValue
});

export const VitalsProvider: React.FC<UseVitalsProps> = function ({ children, ...props }) {
  const vitalsValue = useVitals(props);

  return <VitalsContext.Provider value={vitalsValue}>{children}</VitalsContext.Provider>;
};

export const useVitalsContext = () => useContext(VitalsContext);
